<template>
  <div class="mountain-section attractions">
    <div class="mountain-area">
      <transition-group class="flex-grid flex-grid--halfs" name="fade" mode="out-in" tag="div">
        <template v-for="(area, index) in mountainAreas">
          <Attraction v-for="(attraction, index) in area.Activities" :index="index" :attraction="attraction" :key="attraction.Name"></Attraction>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Attraction from '@/components/MountainAreas/Attraction.vue';

export default {
  name: 'Attractions',
  components: {
    Attraction,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['openStatuses']),
    ...mapState(['mountainAreas']),
  },
  methods: { },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .mountain-section {
      @media (max-width: $tablet) {
        .flex-grid {
          display: block;
          width: 100%;
        }
      }
    }
  }
</style>
